import api from '@/utils/api'
import apiV2 from '@/utils/apiV2'

export const state = () => ({})

export const getters = {}

export const actions = {
  async requestUploadFmFile(_, { payload }) {
    try {
      const { data } = await this.$axiosV2.post(
        apiV2.images.uploadFmImage(),
        payload
      )

      return data
    } catch (err) {
      throw err
    }
  },
  async requestUploadFmDirFile(_, { payload }) {
    try {
      const { data } = await this.$axios.post(
        api.directory.uploadFmDirFile(),
        payload
      )

      return data
    } catch (err) {
      throw err
    }
  },
  async requestUploadIlFile(_, { payload }) {
    try {
      const { data } = await this.$ilAxios.post(
        api.media.uploadIlFile(),
        payload
      )

      return data
    } catch (err) {
      throw err
    }
  },
  async requestUploadIlDirFile(_, { payload }) {
    try {
      const { data } = await this.$ilAxios.post(
        api.directory.uploadIlDirFile(),
        payload
      )

      return data
    } catch (err) {
      throw err
    }
  }
}

export const mutations = {}
